import {
  SELECT_PRODUCT_MOBILE,
  MOTIVE_MESSAGE_MOBILE,
  CHANGE_EMAIL_MOBILE,
  INVOICE_COPY,
  CHANGE_PASS_RIPLEY_COM_MOBILE,
  PROBLEM_IN_PURCHASE,
  PAGE_ERROR,
  EXTEND_VALIDITY,
  GET_GIFTCARD_BALANCE,
  GOLD_DISPATCH_CHARGE_MOBILE,
  PROBLEMS_GIFTCARD_MOBILE,
  CHANGE_PRODUCT_MOBILE,
  NOT_RECEIVED_PRODUCT_MOBILE,
  REMOVE_CLIENT_DATA,
  CHANGE_ADDRESS_MOBILE,
  CHANGE_DATE_MOBILE,
  AUTHORIZE_THIRD_MOBILE,
  ARCO_LAW_INFO,
} from '../constants/routes';

const IssueMapper = new Map([
  ['2', NOT_RECEIVED_PRODUCT_MOBILE],
  ['17', PROBLEM_IN_PURCHASE],
  ['18', INVOICE_COPY],
  ['22', GET_GIFTCARD_BALANCE],
  ['23', MOTIVE_MESSAGE_MOBILE],
  ['26', CHANGE_EMAIL_MOBILE],
  ['27', CHANGE_PASS_RIPLEY_COM_MOBILE],
  ['29', GOLD_DISPATCH_CHARGE_MOBILE],
  ['31', EXTEND_VALIDITY],
  ['32', MOTIVE_MESSAGE_MOBILE],
  ['33', PAGE_ERROR],
  ['28', AUTHORIZE_THIRD_MOBILE],
  ['10', CHANGE_ADDRESS_MOBILE],
  ['1', CHANGE_DATE_MOBILE],
  ['6', SELECT_PRODUCT_MOBILE],
  ['4', SELECT_PRODUCT_MOBILE],
  ['5', SELECT_PRODUCT_MOBILE],
  ['3', SELECT_PRODUCT_MOBILE],
  ['9', SELECT_PRODUCT_MOBILE],
  ['7', SELECT_PRODUCT_MOBILE],
  ['25', MOTIVE_MESSAGE_MOBILE],
  ['24', MOTIVE_MESSAGE_MOBILE],
  ['20', MOTIVE_MESSAGE_MOBILE],
  ['12', MOTIVE_MESSAGE_MOBILE],
  ['37', SELECT_PRODUCT_MOBILE],
  ['11', SELECT_PRODUCT_MOBILE],
  ['35', CHANGE_PRODUCT_MOBILE],
  ['36', PROBLEMS_GIFTCARD_MOBILE],
  ['43', REMOVE_CLIENT_DATA],
  ['44', SELECT_PRODUCT_MOBILE],
  ['45', ARCO_LAW_INFO],
]);

export default IssueMapper;
